export default "__VITE_ASSET__C5ixN3Nf__"